import React, { FunctionComponent, useState } from "react";
import { IAlbum } from "../../../hooks/albums";
import { RightDetailListItem } from "../../RightDetailListItem";
import { strings } from "../../../localization/LocalizedStrings";
import { useUpdateAlbum } from "../../../hooks/albums/useUpdateAlbum";
import { AlertDialog } from "../../AlertDialog";
import { ImpactsDesktop } from "../../attributes/impacts/ImpactsDesktop";
import { StatusCodesHelper } from "../../../models/StatusCodesHelper";
import { toast } from "react-toastify";
import { useIsMobile } from "../../../hooks/isMobile";
import { useUserProfile } from "../../../hooks/session";
import { IImpact } from "../../../hooks/impacts";
import { AttributeDialog } from "../../attributes/AttributeDialog";
import { Stack } from "@mui/material";
import { StarsRating } from "../../attributes/impacts/StarsRating";
import styles from "./styles.module.scss";

export const AlbumImpactListSection: FunctionComponent<IAlbumImpactListSectionProps> = ({
  isPublic,
  album,
  onAttributeUpdated
}) => {
  const isMobile = useIsMobile();
  const [currentUserProfile] = useUserProfile.useState();
  const { updateAlbum } = useUpdateAlbum();
  const [isImpactsDialogOpen, setIsImpactsDialogOpen] = useState(false);
  const [isLoadingImpact, setIsLoadingImpact] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const updateImpact = async (newValue: IImpact | undefined) => {
    setIsLoadingImpact(true);
    setIsImpactsDialogOpen(false);
    const { body, status } = await updateAlbum({
      uuid: album.uuid,
      impactId: newValue?.id ?? null
    });
    if (!StatusCodesHelper.isSuccessful(status)) {
      setAlertMessage(body.message);
      setIsAlertOpen(true);
    } else {
      toast.success(strings.album_update_success);
      onAttributeUpdated(body);
    }
    setIsLoadingImpact(false);
  };
  return (
    <div>
      <RightDetailListItem
        disabled={isPublic}
        title={strings.impact_title}
        detail={
          album.impact ? (
            <Stack className={styles.impactStack} direction={"row"} spacing={2}>
              {currentUserProfile?.shouldShowImpactDescriptions && (
                <p>{album.impact.description}</p>
              )}
              <StarsRating value={album.impact.id} />
            </Stack>
          ) : (
            strings.unknown
          )
        }
        onClick={() => setIsImpactsDialogOpen(true)}
        isLoading={isLoadingImpact}
      />
      <AttributeDialog open={isImpactsDialogOpen} onClose={() => setIsImpactsDialogOpen(false)}>
        <ImpactsDesktop
          handleClose={() => {
            setIsImpactsDialogOpen(false);
          }}
          columnWidth={isMobile ? 6 : 4}
          preselectedId={album.impact?.id}
          onImpactSelected={updateImpact}
          onClearValue={() => updateImpact(undefined)}
        />
      </AttributeDialog>
      <AlertDialog message={alertMessage} open={isAlertOpen} setOpen={setIsAlertOpen} />
    </div>
  );
};

export interface IAlbumImpactListSectionProps {
  isPublic: boolean;
  album: IAlbum;
  onAttributeUpdated: (album: IAlbum) => void;
}
